import type { NicPricingByDeviceType } from '../../../components/nicPricing/utils';
import type { PipelineContext } from '../../../core/types';
import { resolveEnabledModulesForSpecFilter } from '../../_shared/common/sku/resolveEnabledModulesForSpecFilter';
import { hydrateModelInstanceDetailToForm } from '../hydrateFromApiDetail';
import { filterMiSpecByEnabledModules } from './enabledModules';
import { type ModelInstancePayloadOptions, formToPayload } from './payload';
import type { MiSpec } from './schema';

export function miFromForm(values: Record<string, unknown>, ctx: PipelineContext, options?: ModelInstancePayloadOptions): MiSpec {
  const apiSpec = formToPayload(values as Parameters<typeof formToPayload>[0], {
    layout: options?.layout ?? 'modelInstanceApi',
    ...options,
  });
  const nicPricing = (values.network as { nicPricing?: NicPricingByDeviceType } | undefined)?.nicPricing;
  const spec: MiSpec = nicPricing
    ? {
        ...apiSpec,
        network: { ...apiSpec.network, nicPricing },
      }
    : apiSpec;
  const enabledModules = resolveEnabledModulesForSpecFilter(ctx, values);
  return filterMiSpecByEnabledModules(spec, enabledModules, ctx.sku?.skuType);
}

/** spec → 扁平表单（SKU preset 回填 / 展示辅助） */
export function miToForm(spec: MiSpec, _ctx?: PipelineContext): Record<string, unknown> {
  const workload = { spec, metadata: { name: '', namespace: '' } };
  return hydrateModelInstanceDetailToForm(workload) as Record<string, unknown>;
}

export function miGetInitialFormValues(_ctx?: PipelineContext): Record<string, unknown> {
  return {};
}
